import React from 'react'
import { Controller } from "react-hook-form";
import { TextField, Autocomplete } from "@mui/material";


interface AutocompleteProps {
    name: string;
    control: any;
    placeholder?: string;
    label: string;
    required?: boolean;
    jobs?: string[];
    content: string[];
    optionsSelected?: any;
    setOptionsSelected?: any;

}

const AutoCompletePattern = ({ name, control, label, required, jobs, content, optionsSelected, setOptionsSelected, placeholder }: AutocompleteProps) => {

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange } }) => (
                <Autocomplete
                    className="item"
                    placeholder={placeholder}
                    onChange={(event, item) => {
                        onChange(item);
                        setOptionsSelected(item)
                    }}
                    noOptionsText="Aucune option disponible"
                    options={content}
                    isOptionEqualToValue={(option, value) => {
                        return option === value;
                    }}
                    value={value || null}
                    renderInput={(params) => {
                        return (
                            <TextField
                                {...params}
                                label={label}
                                margin="normal"
                                variant="outlined"
                                required={required}
                            />
                        );
                    }}

                />
            )}
        />
    )
}

export default AutoCompletePattern